'use client';

import { FilterChipBar } from './FilterChipBar';
import { useTranslation } from 'react-i18next';
import type { FilterTier } from '@/lib/search-gating';
import {
  activeFilterKeys,
  clearAllFilters,
  describeFilters,
  removeFilter,
} from './activeFilters';
import type { FilterParams } from './CompanySearchSidebar';

export function ActiveFilterBar({
  filters,
  tier,
  onChange,
}: {
  filters: FilterParams;
  tier: FilterTier;
  onChange: (filters: FilterParams) => void;
}) {
  const { t, i18n } = useTranslation();
  const active = new Set(activeFilterKeys(filters, { tier }));
  const chips = describeFilters(filters, { t, lang: i18n.language }).filter((chip) =>
    active.has(chip.key),
  );
  return (
    <FilterChipBar
      chips={chips.map(({ key, label }) => ({
        key,
        label,
        onRemove: () => onChange(removeFilter(filters, key)),
      }))}
      onClearAll={() =>
        onChange(
          clearAllFilters(
            filters,
            chips.map((chip) => chip.key),
          ),
        )
      }
    />
  );
}
